import * as S from './style';
import { Typography as T } from '../../../components';

const GoalProgress = ({ progress = 0 }) => {
  return (
    <S.GoalProgressWrapper>
      <T.P color="white" mr="1">
        {progress}%
      </T.P>

      <S.GoalProgressTube>
        <S.GoalProgressDone percentage={progress} />
      </S.GoalProgressTube>
    </S.GoalProgressWrapper>
  );
};

export default GoalProgress;
